import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

// services
import { AuthHttpInterceptor } from '../auth/auth.http.interceptor';
import { ProfessorsService } from './professors.service';

@NgModule({
  imports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
  ],
})
export class ProfessorsServiceModule {
  static forRoot(): ModuleWithProviders<ProfessorsServiceModule> {
    return {
      ngModule: ProfessorsServiceModule,
      providers: [ProfessorsService],
    };
  }
}
